import applications from './applications.json';

export default {
  applications,
};
